module.exports = __webpack_public_path__ + "img/1-backgroundOne.d1336328.png";